export const SET_DATE_RANGE = "SET_DATE_RANGE";
export const RESET_DATE_RANGE = "RESET_DATE_RANGE";

export const setDateRange = (startDate, endDate) => ({
  type: SET_DATE_RANGE,
  payload: { startDate, endDate },
});

export const resetDateRange = () => ({
  type: RESET_DATE_RANGE,
});
